import angular from 'angular';

export function GiveFocusDesktopDirective () : ng.IDirective {
  return {
    restrict: 'A',
    link ( scope : ng.IScope, element : JQLite ) {
      if (angular.element(window).width() > 1024) {
        setTimeout(() =>{
          element[0].focus({
            preventScroll: true
          });
        });
      }
    }
  }
}
